type CurrencyCountry = {
  code?: string | null;
  currency?: string | null;
  currency_code?: string | null;
  currency_symbol?: string | null;
};

const SYMBOL_BY_COUNTRY: Record<string, string> = {
  OM: 'ر.ع',
  SA: 'ر.س',
  AE: 'د.إ',
  QA: 'ر.ق',
  KW: 'د.ك',
  BH: 'د.ب',
  DZ: 'د.ج',
  EG: 'ج.م',
  MA: 'د.م',
  TN: 'د.ت',
  LY: 'د.ل',
  JO: 'د.أ',
  IQ: 'د.ع',
  LB: 'ل.ل',
  SY: 'ل.س',
  SD: 'ج.س',
};

const SYMBOL_BY_CURRENCY_CODE: Record<string, string> = {
  OMR: 'ر.ع',
  SAR: 'ر.س',
  AED: 'د.إ',
  QAR: 'ر.ق',
  KWD: 'د.ك',
  BHD: 'د.ب',
  DZD: 'د.ج',
  EGP: 'ج.م',
  MAD: 'د.م',
  TND: 'د.ت',
  LYD: 'د.ل',
  JOD: 'د.أ',
  IQD: 'د.ع',
  LBP: 'ل.ل',
  SYP: 'ل.س',
  SDG: 'ج.س',
  EUR: '€',
  GBP: '£',
  USD: '$',
  TRY: '₺',
};

function isIsoCurrency(value: string): boolean {
  return /^[A-Z]{3}$/.test(value.trim().toUpperCase());
}

export function getCurrencyLabel(country?: CurrencyCountry | null, fallbackCountryCode?: string | null): string {
  const countryCode = String(country?.code || fallbackCountryCode || '').trim().toUpperCase();
  const currencyCode = String(country?.currency_code || '').trim().toUpperCase();
  const explicitSymbol = String(country?.currency_symbol || '').trim();
  const legacyCurrency = String(country?.currency || '').trim();

  if (explicitSymbol && !isIsoCurrency(explicitSymbol)) return explicitSymbol;
  if (legacyCurrency && !isIsoCurrency(legacyCurrency)) return legacyCurrency;
  if (countryCode && SYMBOL_BY_COUNTRY[countryCode]) return SYMBOL_BY_COUNTRY[countryCode];
  if (currencyCode && SYMBOL_BY_CURRENCY_CODE[currencyCode]) return SYMBOL_BY_CURRENCY_CODE[currencyCode];
  if (legacyCurrency && SYMBOL_BY_CURRENCY_CODE[legacyCurrency.toUpperCase()]) {
    return SYMBOL_BY_CURRENCY_CODE[legacyCurrency.toUpperCase()];
  }
  return explicitSymbol || legacyCurrency || 'ر.ع';
}

